export const IS_REQUIRED = 'isRequired';
export const MAX_COUNT = 'maxCount';
export const MIN_COUNT = 'minCount';
